<template>
    <div class="footer">
      <span class="span">电梯大叔@2019@Orioc&nbsp;&nbsp;&nbsp;&nbsp;<a target="_blank" 
        href="https://beian.miit.gov.cn/">皖ICP备  皖B2-20160025-7</a></span>
    
      <h6>全国统一服务热线：400-0616-112</h6>
    </div>
</template>

<script>
  export default {
    name: "index"
  }
</script>

<style lang="scss" scoped>
  .footer{
    text-align: center;
    padding: 15px 0;
    background: white;
    box-shadow: 0px -2px 28px -2px rgba(0,0,0,0.07);
    .span{
      margin-bottom: 5px;
      display: block;
      font-size: 10px;
      color: #9e9f9f;
    }
    h6{
      font-size: 12px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Footer/index.vue